import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Field } from '@ascschool/interface/form/field';
import { Subscription } from 'rxjs';

// text,email,tel,textarea,password, 
@Component({
    selector: 'radio-checkbox-field',
    template: `        
        <!-- <input 
          nz-input  
          [name]="field.controlName" 
          [id]="field.controlName" 
          [placeholder]="field.placeholder"
          [formControl]="formControl"
          > -->
        <nz-radio-group [formControl]="formControl">
            <label *ngFor="let option of field.options" nz-radio [nzValue]="option.key">{{ option.lable }}</label>
        </nz-radio-group>
    `,
      providers: [
        {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => RadioCheckBoxFieldComponent),
          multi: true
        }
      ]
})
export class RadioCheckBoxFieldComponent implements ControlValueAccessor {
    @Input() field : Field;
    @Input() form : FormGroup;
    formControl = new FormControl('');
    subscription: Subscription;
    private onChange: Function;
    private onTouched: Function;  
    ngOnInit() {
      this.subscription = this.formControl.valueChanges
        .subscribe((v) => {
          this.onChange && this.onChange(v);
        })
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    writeValue(obj: any) {
      this.formControl.setValue(obj);
    }

    registerOnChange(fn: any) {
      this.onChange = fn;
    }

    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean) {
    }
    constructor() {

    }
}